var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBorderMarketItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_69878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.8102 51.5865C98.8102 46.4905 98.0175 41.5077 96.4321 36.8646L99.4897 31.3155C96.9983 25.3135 93.2612 19.6512 88.3916 14.7817C83.5221 9.91211 77.8598 6.175 71.8578 3.68359L66.3087 6.74123C61.6656 5.26903 56.7961 4.36307 51.5868 4.36307C46.3775 4.36307 41.5079 5.15579 36.8648 6.74123L31.3158 3.68359C25.3138 6.175 19.6515 9.91211 14.7819 14.7817C9.91235 19.6512 6.17524 25.3135 3.68384 31.3155L6.74147 36.8646C5.26928 41.5077 4.36331 46.3772 4.36331 51.5865C4.36331 56.6826 5.15603 61.6654 6.74147 66.3085L3.68384 71.8575C6.17524 77.8595 9.91235 83.5218 14.7819 88.3914C19.6515 93.261 25.3138 96.9981 31.3158 99.4895L36.8648 96.4318C41.5079 97.904 46.3775 98.81 51.5868 98.81C56.6828 98.81 61.6656 98.0173 66.3087 96.4318L71.8578 99.4895C77.8598 96.9981 83.5221 93.261 88.3916 88.3914C93.2612 83.5218 96.9983 77.8595 99.4897 71.8575L96.4321 66.3085C98.0175 61.6654 98.8102 56.6826 98.8102 51.5865ZM5.49577 51.5865C5.49577 26.2195 26.2197 5.49553 51.5868 5.49553C76.9538 5.49553 97.6778 26.2195 97.6778 51.5865C97.6778 76.9536 76.9538 97.6775 51.5868 97.6775C26.1065 97.6775 5.49577 76.9536 5.49577 51.5865Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5865 2.66426C56.3429 2.66426 60.9859 3.34373 65.4025 4.58943L68.3469 3.00399C63.1376 1.19206 57.4753 0.172852 51.5865 0.172852C45.6978 0.172852 40.0355 1.19206 34.8262 3.00399L37.7706 4.58943C42.1871 3.34373 46.8302 2.66426 51.5865 2.66426Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.6645 51.5865C2.6645 46.8302 3.34398 42.1871 4.58968 37.7706L3.00424 34.8262C1.19231 40.0355 0.173096 45.6978 0.173096 51.5865C0.173096 57.4753 1.19231 63.1376 3.00424 68.3469L4.58968 65.4025C3.34398 60.9859 2.6645 56.3429 2.6645 51.5865Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5865 100.509C46.8302 100.509 42.1871 99.8292 37.7706 98.5835L34.8262 100.169C40.0355 101.981 45.6978 103 51.5865 103C57.4753 103 63.1376 101.981 68.3469 100.169L65.4025 98.5835C60.9859 99.8292 56.3429 100.509 51.5865 100.509Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.169 34.8262L98.5835 37.7706C99.8292 42.1871 100.509 46.717 100.509 51.5865C100.509 56.4561 99.8292 60.9859 98.5835 65.4025L100.169 68.3469C101.981 63.1376 103 57.4753 103 51.5865C103 45.6978 101.981 40.0355 100.169 34.8262Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7453 61.3252H12.9697C15.1214 69.8186 19.991 77.1796 26.5592 82.5021L30.5228 78.5385C24.9738 74.2352 20.7837 68.2332 18.7453 61.3252Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2729 51.5864C17.2729 45.6976 18.7451 40.1486 21.463 35.279L17.3862 31.2021C13.7623 37.2042 11.7239 44.1122 11.7239 51.5864C11.7239 53.0586 11.8371 54.4175 11.9504 55.7765H17.4994C17.3862 54.4175 17.2729 53.0586 17.2729 51.5864Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7865 51.5861C85.7865 57.4749 84.3143 63.0239 81.5964 67.8935L85.6733 71.9703C89.2971 65.9683 91.3356 59.0603 91.3356 51.5861C91.3356 50.1139 91.2223 48.7549 91.1091 47.396H85.56C85.7865 48.7549 85.7865 50.1139 85.7865 51.5861Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5005 20.6699L72.6501 24.5203C78.1992 28.8236 82.3893 34.8256 84.4277 41.7336H90.2032C88.0516 33.3534 83.182 25.9925 76.5005 20.6699Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.539 72.6499C74.2357 78.1989 68.2337 82.389 61.3257 84.4275V90.203C69.8191 88.0513 77.1801 83.1818 82.5026 76.6135L78.539 72.6499Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3965 17.6124C48.7554 17.386 50.2276 17.386 51.5866 17.386C57.4754 17.386 63.0244 18.8581 67.894 21.576L71.9708 17.4992C65.9688 13.8753 59.0608 11.8369 51.5866 11.8369C50.1144 11.8369 48.7554 11.9502 47.3965 12.0634V17.6124Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7765 85.5603C54.4175 85.7868 52.9453 85.7868 51.5864 85.7868C45.6976 85.7868 40.1486 84.3146 35.279 81.5967L31.2021 85.6735C37.2042 89.2974 44.1122 91.3358 51.5864 91.3358C53.0586 91.3358 54.4175 91.2226 55.7765 91.1093V85.5603Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5207 30.5223C28.8241 24.9733 34.8261 20.7832 41.7341 18.7448V12.9692C33.2406 15.1209 25.8797 19.9905 20.5571 26.5587L24.5207 30.5223Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.6802 7.19385H49.8875V7.98657H50.6802V7.19385Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.567 8.21289H50.114V8.66587H50.567V8.21289Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.4538 9.00586H50.114V9.3456H50.4538V9.00586Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.0393 7.19385H51.2466V7.98657H52.0393V7.19385Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.8128 8.21289H51.3599V8.66587H51.8128V8.21289Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6996 9.00586H51.3599V9.3456H51.6996V9.00586Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.2852 7.19385H52.4924V7.98657H53.2852V7.19385Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.0587 8.21289H52.6057V8.66587H53.0587V8.21289Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.9457 9.00586H52.606V9.3456H52.9457V9.00586Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.5769 10.1443L34.832 10.4155L35.1033 11.1604L35.8481 10.8891L35.5769 10.1443Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.765 11.2165L35.3394 11.3716L35.4944 11.7972L35.92 11.6421L35.765 11.2165Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.0009 11.8999L35.6816 12.0161L35.7978 12.3354L36.1171 12.2192L36.0009 11.8999Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.8098 9.66818L36.0649 9.93945L36.3362 10.6843L37.0811 10.413L36.8098 9.66818Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.9967 10.741L36.571 10.896L36.7261 11.3216L37.1517 11.1666L36.9967 10.741Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.1276 11.4613L36.8083 11.5776L36.9246 11.8969L37.2439 11.7806L37.1276 11.4613Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.9383 9.23028L37.1934 9.50146L37.4645 10.2464L38.2095 9.97519L37.9383 9.23028Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M38.1249 10.3042L37.6992 10.459L37.854 10.8847L38.2798 10.7299L38.1249 10.3042Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.2533 11.0244L37.9341 11.1406L38.0503 11.4599L38.3695 11.3437L38.2533 11.0244Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.3833 18.1262L21.7761 18.6357L22.2857 19.243L22.8929 18.7334L22.3833 18.1262Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9365 18.9709L22.5896 19.2622L22.8809 19.6091L23.2278 19.3179L22.9365 18.9709Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.324 19.5976L23.0637 19.8159L23.2821 20.0762L23.5424 19.8579L23.324 19.5976Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.3956 17.2917L22.7883 17.8013L23.2979 18.4085L23.9051 17.8989L23.3956 17.2917Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.8612 18.2104L23.5142 18.5015L23.8052 18.8485L24.1523 18.5575L23.8612 18.2104Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.2498 18.8359L23.9895 19.0542L24.2079 19.3145L24.4682 19.0962L24.2498 18.8359Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.323 16.5304L23.7158 17.04L24.2255 17.6473L24.8327 17.1376L24.323 16.5304Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.7879 17.4471L24.4409 17.7383L24.7321 18.0853L25.0791 17.794L24.7879 17.4471Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.2595 18.0009L24.9993 18.2192L25.2176 18.4795L25.4779 18.2612L25.2595 18.0009Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.7066 30.151L12.3101 30.8374L12.9965 31.2339L13.393 30.5475L12.7066 30.151Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.4808 30.8347L13.2544 31.2271L13.6467 31.4535L13.8732 31.0612L13.4808 30.8347Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.0571 31.2082L13.8872 31.5024L14.1814 31.6723L14.3513 31.3781L14.0571 31.2082Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.3155 28.9951L12.9192 29.6816L13.6057 30.078L14.002 29.3915L13.3155 28.9951Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.0879 29.6781L13.8613 30.0703L14.2536 30.2968L14.4801 29.9046L14.0879 29.6781Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.765 30.112L14.5952 30.4062L14.8895 30.576L15.0593 30.2817L14.765 30.112Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.9683 27.9951L13.572 28.6816L14.2586 29.0779L14.6549 28.3913L13.9683 27.9951Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.7407 28.678L14.5142 29.0703L14.9064 29.2968L15.1329 28.9045L14.7407 28.678Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.3192 29.0549L15.1494 29.3491L15.4437 29.519L15.6135 29.2247L15.3192 29.0549Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.71313 44.6681L7.57544 45.4487L8.35611 45.5864L8.4938 44.8058L7.71313 44.6681Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.73678 45.0491L8.65796 45.4951L9.10401 45.5739L9.18283 45.1279L8.73678 45.0491Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.39492 45.2855L9.33594 45.6201L9.67051 45.6791L9.72949 45.3445L9.39492 45.2855Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M7.91659 43.4234L7.77905 44.2041L8.55972 44.3416L8.69726 43.561L7.91659 43.4234Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.94445 43.8059L8.86572 44.252L9.31182 44.3307L9.39055 43.8846L8.94445 43.8059Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.60153 44.0443L9.54248 44.3789L9.87705 44.438L9.9361 44.1034L9.60153 44.0443Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.12191 42.1803L7.98438 42.9609L8.76505 43.0985L8.90258 42.3178L8.12191 42.1803Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.14846 42.5627L9.06982 43.0088L9.51592 43.0874L9.59456 42.6413L9.14846 42.5627Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.80762 42.8012L9.74854 43.1357L10.0831 43.1948L10.1422 42.8602L9.80762 42.8012Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.82022 60.0046L8.03955 60.1421L8.17709 60.9228L8.95776 60.7852L8.82022 60.0046Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.5313 60.0371L9.08521 60.1157L9.16384 60.5618L9.60994 60.4832L9.5313 60.0371Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M10.0985 59.9473L9.76392 60.0063L9.82296 60.3409L10.1575 60.2819L10.0985 59.9473Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.59317 58.7613L7.8125 58.8989L7.95012 59.6796L8.73079 59.542L8.59317 58.7613Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.30108 58.7958L8.85498 58.8745L8.93371 59.3206L9.37981 59.2419L9.30108 58.7958Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.86997 58.7032L9.5354 58.7622L9.59445 59.0968L9.92902 59.0377L9.86997 58.7032Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.36612 57.5176L7.58545 57.6553L7.72314 58.4359L8.50382 58.2982L8.36612 57.5176Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.07227 57.5481L8.62622 57.627L8.70504 58.073L9.15109 57.9942L9.07227 57.5481Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M9.64292 57.4566L9.30835 57.5156L9.36733 57.8502L9.7019 57.7912L9.64292 57.4566Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1727 74.114L13.4861 74.5103L13.8824 75.1968L14.5689 74.8005L14.1727 74.114Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.8769 73.9606L14.4846 74.187L14.7111 74.5793L15.1034 74.3529L14.8769 73.9606Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.4524 73.6334L15.1582 73.8032L15.3281 74.0974L15.6223 73.9276L15.4524 73.6334Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.6316 73.0559L12.9451 73.4521L13.3413 74.1387L14.0279 73.7424L13.6316 73.0559Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M14.276 72.7989L13.8838 73.0254L14.1103 73.4176L14.5026 73.1911L14.276 72.7989Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9146 72.5749L14.6204 72.7446L14.7901 73.0389L15.0844 72.8691L14.9146 72.5749Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M12.9336 71.9547L12.2471 72.3511L12.6434 73.0376L13.3299 72.6412L12.9336 71.9547Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.6428 71.7999L13.2505 72.0264L13.4769 72.4187L13.8693 72.1923L13.6428 71.7999Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.2107 71.4766L13.9165 71.6465L14.0864 71.9407L14.3806 71.7708L14.2107 71.4766Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M24.1652 85.5227L23.6555 86.1299L24.2627 86.6395L24.7724 86.0323L24.1652 85.5227Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.7634 85.1677L24.4722 85.5146L24.8192 85.8059L25.1104 85.4589L24.7634 85.1677Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M25.1837 84.6094L24.9653 84.8696L25.2256 85.088L25.444 84.8277L25.1837 84.6094Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M23.2408 84.6863L22.7312 85.2935L23.3383 85.8031L23.848 85.196L23.2408 84.6863Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.8481 84.3278L23.5569 84.6748L23.9039 84.966L24.1951 84.619L23.8481 84.3278Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.1954 83.8545L23.9771 84.1147L24.2373 84.3331L24.4557 84.0729L24.1954 83.8545Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.2566 83.9332L21.7471 84.5405L22.3544 85.05L22.8639 84.4427L22.2566 83.9332Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.844 83.4235L22.5527 83.7705L22.8997 84.0617L23.1909 83.7147L22.844 83.4235Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.2862 83.0229L23.0679 83.2832L23.3282 83.5016L23.5465 83.2412L23.2862 83.0229Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M37.5179 92.8669L37.2468 93.6118L37.9917 93.8829L38.2629 93.138L37.5179 92.8669Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M37.7962 92.2257L37.6414 92.6514L38.067 92.8062L38.2219 92.3806L37.7962 92.2257Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M38.078 91.7198L37.9617 92.0391L38.2809 92.1554L38.3972 91.8361L38.078 91.7198Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36.3369 92.3908L36.0657 93.1357L36.8106 93.4069L37.0818 92.662L36.3369 92.3908Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M36.7245 91.7838L36.5696 92.2095L36.9952 92.3644L37.1502 91.9388L36.7245 91.7838Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M36.8936 91.2433L36.7773 91.5625L37.0966 91.6788L37.2128 91.3596L36.8936 91.2433Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M35.1137 92.0202L34.8425 92.7651L35.5875 93.0363L35.8586 92.2914L35.1137 92.0202Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M35.495 91.4176L35.3401 91.8433L35.7658 91.9981L35.9206 91.5725L35.495 91.4176Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.8155 90.8053L35.6992 91.1245L36.0184 91.2408L36.1347 90.9216L35.8155 90.8053Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M53.2849 95.1846H52.4922V95.9773H53.2849V95.1846Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M53.0585 94.5059H52.6055V94.9588H53.0585V94.5059Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M52.9452 93.8262H52.6055V94.1659H52.9452V93.8262Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M52.0393 95.1846H51.2466V95.9773H52.0393V95.1846Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M51.8128 94.5059H51.3599V94.9588H51.8128V94.5059Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.6996 93.8262H51.3599V94.1659H51.6996V93.8262Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50.6802 95.1846H49.8875V95.9773H50.6802V95.1846Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M50.567 94.5059H50.114V94.9588H50.567V94.5059Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M50.4538 93.8262H50.114V94.1659H50.4538V93.8262Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M68.0757 92.012L67.3308 92.2832L67.602 93.0281L68.3469 92.7569L68.0757 92.012Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.5763 91.4032L67.1506 91.5581L67.3055 91.9838L67.7312 91.8289L67.5763 91.4032Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.3812 90.8261L67.062 90.9424L67.1783 91.2616L67.4975 91.1453L67.3812 90.8261Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.8401 92.4847L66.0952 92.7559L66.3663 93.5008L67.1112 93.2297L66.8401 92.4847Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.4528 91.8408L66.0271 91.9956L66.1819 92.4213L66.6076 92.2665L66.4528 91.8408Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M66.1124 91.1982L65.7932 91.3145L65.9095 91.6337L66.2287 91.5174L66.1124 91.1982Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.71 92.9204L64.9651 93.1914L65.2361 93.9363L65.981 93.6653L65.71 92.9204Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M65.2836 92.1786L64.8579 92.3335L65.0128 92.7592L65.4385 92.6042L65.2836 92.1786Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.983 91.6323L64.6638 91.7485L64.7801 92.0677L65.0993 91.9515L64.983 91.6323Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M80.8927 83.9134L80.2854 84.4229L80.7949 85.0302L81.4022 84.5207L80.8927 83.9134Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.2264 83.4628L79.8794 83.7539L80.1705 84.1009L80.5176 83.8098L80.2264 83.4628Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.8252 82.9886L79.5649 83.207L79.7833 83.4673L80.0436 83.2489L79.8252 82.9886Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.8865 84.7482L79.2793 85.2578L79.7889 85.865L80.3962 85.3554L79.8865 84.7482Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.3736 84.3104L79.0266 84.6016L79.3177 84.9486L79.6648 84.6575L79.3736 84.3104Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.8147 83.8222L78.5544 84.0405L78.7728 84.3008L79.0331 84.0825L78.8147 83.8222Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.955 85.5125L78.3477 86.022L78.8571 86.6293L79.4644 86.1198L78.955 85.5125Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.368 85.1424L78.021 85.4336L78.3122 85.7806L78.6592 85.4894L78.368 85.1424Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.8872 84.5897L77.627 84.8081L77.8453 85.0683L78.1056 84.85L77.8872 84.5897Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.1844 71.9077L89.7881 72.5942L90.4747 72.9905L90.8709 72.3039L90.1844 71.9077Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.475 71.7884L89.2485 72.1807L89.6408 72.4072L89.8673 72.0149L89.475 71.7884Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.846 71.5149L88.676 71.8091L88.9702 71.9791L89.1402 71.6849L88.846 71.5149Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.5752 73.0748L89.1787 73.7612L89.8651 74.1577L90.2616 73.4713L89.5752 73.0748Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.8219 72.7903L88.5955 73.1826L88.9878 73.409L89.2142 73.0167L88.8219 72.7903Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.2932 72.5686L88.1233 72.8628L88.4175 73.0327L88.5874 72.7385L88.2932 72.5686Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.9186 74.065L88.5222 74.7515L89.2087 75.1478L89.6051 74.4613L88.9186 74.065Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.2146 73.9401L87.9883 74.3325L88.3807 74.5589L88.607 74.1665L88.2146 73.9401Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.5854 73.6667L87.4155 73.9609L87.7097 74.1308L87.8796 73.8366L87.5854 73.6667Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.8254 57.5454L94.688 58.3262L95.4687 58.4636L95.6062 57.6829L94.8254 57.5454Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.0644 57.5593L93.9858 58.0054L94.4319 58.084L94.5105 57.6379L94.0644 57.5593Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.3779 57.5438L93.3188 57.8784L93.6534 57.9375L93.7125 57.6029L93.3779 57.5438Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.6143 58.7906L94.4766 59.5713L95.2572 59.709L95.3949 58.9283L94.6143 58.7906Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.8653 58.8054L93.7866 59.2515L94.2327 59.3301L94.3114 58.884L93.8653 58.8054Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.1637 58.7894L93.1047 59.124L93.4393 59.183L93.4983 58.8484L93.1637 58.7894Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.4115 60.0333L94.2737 60.814L95.0543 60.9517L95.1921 60.1711L94.4115 60.0333Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M93.6614 60.05L93.5828 60.4961L94.0289 60.5747L94.1075 60.1286L93.6614 60.05Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M92.9603 60.0341L92.9014 60.3687L93.2359 60.4276L93.2949 60.093L92.9603 60.0341Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M94.9994 42.247L94.2188 42.3848L94.3565 43.1654L95.1372 43.0277L94.9994 42.247Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.0115 42.6059L93.5654 42.6846L93.6441 43.1307L94.0902 43.052L94.0115 42.6059Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.2201 42.7335L92.8855 42.7925L92.9445 43.1271L93.279 43.0681L93.2201 42.7335Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95.2267 43.4883L94.446 43.626L94.5837 44.4066L95.3644 44.269L95.2267 43.4883Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.2405 43.8471L93.7944 43.9258L93.8731 44.3719L94.3192 44.2932L94.2405 43.8471Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.4469 43.9782L93.1123 44.0371L93.1712 44.3717L93.5058 44.3127L93.4469 43.9782Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95.4503 44.7317L94.6697 44.8691L94.8071 45.6498L95.5878 45.5124L95.4503 44.7317Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.4695 45.0908L94.0234 45.1694L94.1021 45.6155L94.5482 45.5369L94.4695 45.0908Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M93.681 45.2295L93.3464 45.2886L93.4055 45.6231L93.7401 45.5641L93.681 45.2295Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.2932 27.964L88.6067 28.3604L89.003 29.0468L89.6895 28.6505L89.2932 27.964Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M88.3706 28.6354L87.9783 28.8618L88.2047 29.2541L88.597 29.0277L88.3706 28.6354Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.6965 29.022L87.4023 29.1919L87.5723 29.4861L87.8665 29.3161L87.6965 29.022Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M89.8352 29.0216L89.1487 29.418L89.545 30.1045L90.2315 29.7081L89.8352 29.0216Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.0127 29.6461L88.6204 29.8726L88.8468 30.2649L89.2391 30.0384L89.0127 29.6461Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.3965 30.1192L88.1023 30.2891L88.2722 30.5833L88.5664 30.4134L88.3965 30.1192Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90.5334 30.1271L89.8469 30.5234L90.2433 31.2099L90.9298 30.8136L90.5334 30.1271Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M89.6111 30.7994L89.2188 31.0259L89.4452 31.4182L89.8375 31.1918L89.6111 30.7994Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M88.9358 31.1797L88.6416 31.3496L88.8115 31.6438L89.1057 31.4739L88.9358 31.1797Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M78.9189 16.5079L78.4094 17.1152L79.0167 17.6247L79.5262 17.0174L78.9189 16.5079Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M78.2944 17.4299L78.0032 17.7769L78.3502 18.0681L78.6414 17.7211L78.2944 17.4299Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.8639 17.9902L77.6455 18.2505L77.9057 18.4689L78.1241 18.2086L77.8639 17.9902Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M79.8367 17.3479L79.3271 17.9551L79.9344 18.4646L80.4439 17.8574L79.8367 17.3479Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M79.2839 18.1804L78.9927 18.5273L79.3397 18.8186L79.6309 18.4716L79.2839 18.1804Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M78.7822 18.8251L78.564 19.0854L78.8243 19.3037L79.0426 19.0434L78.7822 18.8251Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M80.8252 18.0983L80.3157 18.7056L80.9229 19.2151L81.4325 18.6079L80.8252 18.0983Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.2006 19.0167L79.9094 19.3638L80.2565 19.6549L80.5476 19.3079L80.2006 19.0167Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M79.7701 19.5796L79.5518 19.8398L79.812 20.0582L80.0304 19.798L79.7701 19.5796Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.1892 9.25508L64.918 10L65.6629 10.2712L65.9341 9.52627L65.1892 9.25508Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M64.9992 10.2941L64.8442 10.7197L65.2699 10.8746L65.4248 10.449L64.9992 10.2941Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M64.7524 11.0557L64.6362 11.375L64.9555 11.4912L65.0716 11.1719L64.7524 11.0557Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M66.3741 9.73368L66.1028 10.4785L66.8476 10.7498L67.1189 10.0049L66.3741 9.73368Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M66.1858 10.7687L66.0308 11.1943L66.4564 11.3494L66.6114 10.9238L66.1858 10.7687Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.94 11.5284L65.8237 11.8477L66.1429 11.9639L66.2592 11.6447L65.94 11.5284Z",
    fill: "#1F2933"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M67.5975 10.1023L67.3262 10.8472L68.071 11.1185L68.3424 10.3737L67.5975 10.1023Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M67.3708 11.2443L67.2158 11.6699L67.6415 11.8249L67.7965 11.3992L67.3708 11.2443Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.1599 11.901L67.0437 12.2202L67.363 12.3364L67.4791 12.0171L67.1599 11.901Z",
    fill: "#1F2933"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3704,
    d: "M29.3904 30.2961L28.3711 29.2769C27.0122 30.749 25.7665 32.3345 24.634 33.9199L25.8797 34.7126C26.8989 33.1272 28.1446 31.655 29.3904 30.2961Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2922,
    d: "M48.3023 21.0103L48.1891 19.5381C46.1506 19.7646 44.2255 20.1043 42.3003 20.6705L42.7533 22.0295C44.5652 21.5765 46.3771 21.2368 48.3023 21.0103Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2413,
    d: "M41.3944 22.5953L40.9414 21.2363C39.0162 21.9158 37.2043 22.7085 35.5056 23.7277L36.2983 24.9734C37.7705 24.0675 39.5825 23.2747 41.3944 22.5953Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3377,
    d: "M20.897 51.5862C20.897 50.9068 20.897 50.2273 21.0102 49.5478L19.4248 49.4346C19.4248 50.114 19.3115 50.9068 19.3115 51.5862C19.3115 52.8319 19.4248 54.0776 19.538 55.3233L21.0102 55.0969C20.897 53.9644 20.897 52.8319 20.897 51.5862Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3655,
    d: "M25.0869 35.9582L23.8412 35.1655C22.822 36.8642 21.916 38.6761 21.2366 40.6013L22.5955 41.0543C23.3882 39.3556 24.181 37.5437 25.0869 35.9582Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3084,
    d: "M21.2366 56.5688L19.7644 56.7953C20.1041 58.7205 20.5571 60.7589 21.2366 62.5709L22.5955 62.1179C22.0293 60.306 21.5763 58.494 21.2366 56.5688Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3631,
    d: "M22.256 42.5262L20.7838 42.0732C20.2176 43.9984 19.7646 45.9236 19.5381 47.962L21.0103 48.0753C21.2368 46.1501 21.6898 44.3382 22.256 42.5262Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3941,
    d: "M81.0304 42.9796L82.5026 42.5266C81.9363 40.6014 81.2569 38.7895 80.3509 36.9775L78.9919 37.657C79.8979 39.3557 80.5774 41.1676 81.0304 42.9796Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2488,
    d: "M78.3124 36.4113L79.5581 35.7319C78.5389 34.0332 77.4065 32.3345 76.1608 30.8623L75.0283 31.7683C76.274 33.2405 77.4065 34.8259 78.3124 36.4113Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3483,
    d: "M82.2759 50.001L83.7481 49.8878C83.6348 47.8494 83.4083 45.9242 82.9553 43.999L81.4832 44.3388C81.9361 46.2639 82.1626 48.1891 82.2759 50.001Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3022,
    d: "M69.4791 24.86C67.7805 23.7275 66.0818 22.8215 64.2698 22.0288L63.7036 23.3878C65.4023 24.1805 67.101 25.0864 68.6864 26.1057L69.4791 24.86Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2369,
    d: "M62.9112 21.4629C61.0992 20.7834 59.0608 20.2172 57.1356 19.8774L56.7959 21.3496C58.7211 21.6894 60.533 22.1424 62.3449 22.8218L62.9112 21.4629Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3913,
    d: "M74.1222 30.7489L75.2547 29.7297C73.8957 28.2575 72.4235 26.8986 70.8381 25.7661L69.9321 26.8986C71.4043 28.031 72.7633 29.2767 74.1222 30.7489Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3453,
    d: "M34.9392 25.7662L34.1465 24.5205C32.4478 25.653 30.8623 26.8987 29.3901 28.2576L30.4093 29.2768C31.8815 27.9179 33.3537 26.7854 34.9392 25.7662Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3625,
    d: "M76.0476 70.1586L77.1801 71.0646C78.4258 69.4792 79.445 67.7805 80.3509 65.9685L78.992 65.2891C78.1993 67.101 77.1801 68.6864 76.0476 70.1586Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.319,
    d: "M71.0647 75.3679L71.9707 76.5004C73.5561 75.2547 74.915 73.7825 76.274 72.3103L75.1415 71.4043C73.8958 72.7632 72.5369 74.1222 71.0647 75.3679Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2217,
    d: "M58.3811 81.4829L58.7208 82.9551C60.646 82.5021 62.5712 81.9358 64.3831 81.1431L63.8169 79.7842C62.005 80.5769 60.193 81.1431 58.3811 81.4829Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2014,
    d: "M65.0627 79.2183L65.7422 80.5773C67.5542 79.6713 69.2528 78.6521 70.8383 77.4064L69.9323 76.2739C68.3469 77.2931 66.7614 78.3124 65.0627 79.2183Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.389,
    d: "M82.2762 51.4731C82.2762 53.5115 82.0497 55.4367 81.71 57.2486L83.1822 57.4751C83.5219 55.55 83.7484 53.5115 83.7484 51.4731V51.3599H82.2762V51.4731Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2537,
    d: "M79.6716 64.0432L81.0306 64.6094C81.8233 62.7975 82.5028 60.8723 82.9558 58.9472L81.4836 58.6074C81.0306 60.5326 80.4644 62.3445 79.6716 64.0432Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3207,
    d: "M36.8645 80.2374C38.6764 81.1434 40.4884 81.9361 42.4135 82.5023L42.8665 81.1434C41.0546 80.5771 39.2427 79.8977 37.544 78.9917L36.8645 80.2374Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2266,
    d: "M30.636 76.047C32.1082 77.2927 33.8069 78.5384 35.5056 79.5577L36.2983 78.312C34.5996 77.406 33.1274 76.2735 31.6552 75.0278L30.636 76.047Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2672,
    d: "M23.2752 63.4771L21.9163 64.0433C22.709 65.8552 23.6149 67.6671 24.7474 69.3658L25.9931 68.5731C24.8606 66.8744 23.9547 65.1757 23.2752 63.4771Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2126,
    d: "M26.7855 69.7056L25.5398 70.6115C26.6723 72.197 28.0312 73.7824 29.5034 75.1414L30.5226 74.1222C29.1637 72.65 27.918 71.1778 26.7855 69.7056Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3623,
    d: "M51.5863 82.2757H51.2466V83.7479H51.5863C53.5115 83.7479 55.3234 83.6347 57.2486 83.295L57.0221 81.8228C55.2102 82.1625 53.3983 82.2757 51.5863 82.2757Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3262,
    d: "M55.5501 19.6508C53.6249 19.4243 51.5865 19.3111 49.5481 19.4243L49.6613 20.8965C51.5865 20.7833 53.5117 20.8965 55.3236 21.123L55.5501 19.6508Z",
    fill: "#1F2933"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3033,
    d: "M43.7727 82.8419C45.6979 83.2948 47.7363 83.6346 49.6615 83.7478L49.7747 82.2756C47.8495 82.1624 45.9244 81.9359 44.1124 81.4829L43.7727 82.8419Z",
    fill: "#1F2933"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_69878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103,
    height: 103,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorderMarketItem);
export default __webpack_public_path__ + "static/media/borderMarketItem.7cff91201a9c6d8e837d7d413c0ce2d9.svg";
export { ForwardRef as ReactComponent };